import React from 'react';
import { motion } from 'framer-motion';

interface ConfidenceBarProps {
  confidence: number;
}

export const ConfidenceBar: React.FC<ConfidenceBarProps> = ({ confidence }) => {
  const pct = confidence * 100;
  const gradient =
    pct >= 85
      ? 'linear-gradient(90deg, #14b8a6, #2dd4bf)'
      : pct >= 65
      ? 'linear-gradient(90deg, #0ea5e9, #38bdf8)'
      : 'linear-gradient(90deg, #f59e0b, #fbbf24)';

  const glow =
    pct >= 85
      ? 'rgba(45,212,191,0.5)'
      : pct >= 65
      ? 'rgba(14,165,233,0.5)'
      : 'rgba(245,158,11,0.5)';

  return (
    <div
      className="w-full rounded-full overflow-hidden"
      style={{ height: '4px', background: 'rgba(255,255,255,0.06)' }}
    >
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: `${pct}%` }}
        transition={{ duration: 0.35, ease: 'easeOut' }}
        style={{
          height: '100%',
          background: gradient,
          boxShadow: `0 0 8px ${glow}`,
          borderRadius: '9999px',
        }}
      />
    </div>
  );
};
